"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Practice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchedulerToJSON = exports.SchedulerFromJSONTyped = exports.SchedulerFromJSON = exports.instanceOfScheduler = exports.SchedulerStatusEnum = void 0;
const runtime_1 = require("../runtime");
const SchedulerCommunicationInner_1 = require("./SchedulerCommunicationInner");
const SchedulerGroupScheduler_1 = require("./SchedulerGroupScheduler");
const SchedulerReschedulingOptions_1 = require("./SchedulerReschedulingOptions");
const SchedulerRoundRobin_1 = require("./SchedulerRoundRobin");
/**
* @export
* @enum {string}
*/
var SchedulerStatusEnum;
(function (SchedulerStatusEnum) {
    SchedulerStatusEnum["Active"] = "active";
    SchedulerStatusEnum["Inactive"] = "inactive";
    SchedulerStatusEnum["Deleted"] = "deleted";
})(SchedulerStatusEnum || (exports.SchedulerStatusEnum = SchedulerStatusEnum = {}));
/**
 * Check if a given object implements the Scheduler interface.
 */
function instanceOfScheduler(value) {
    let isInstance = true;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "icon" in value;
    isInstance = isInstance && "communication" in value;
    return isInstance;
}
exports.instanceOfScheduler = instanceOfScheduler;
function SchedulerFromJSON(json) {
    return SchedulerFromJSONTyped(json, false);
}
exports.SchedulerFromJSON = SchedulerFromJSON;
function SchedulerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'title': json['title'],
        'status': json['status'],
        'slug': !(0, runtime_1.exists)(json, 'slug') ? undefined : json['slug'],
        'smartActions': !(0, runtime_1.exists)(json, 'smartActions') ? undefined : json['smartActions'],
        'messagingInvite': !(0, runtime_1.exists)(json, 'messagingInvite') ? undefined : json['messagingInvite'],
        'icon': json['icon'],
        'duration': !(0, runtime_1.exists)(json, 'duration') ? undefined : json['duration'],
        'communication': (json['communication'].map(SchedulerCommunicationInner_1.SchedulerCommunicationInnerFromJSON)),
        'availabilityId': !(0, runtime_1.exists)(json, 'availabilityId') ? undefined : json['availabilityId'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'sharedWith': !(0, runtime_1.exists)(json, 'sharedWith') ? undefined : json['sharedWith'],
        'bufferTimeAfter': !(0, runtime_1.exists)(json, 'bufferTimeAfter') ? undefined : json['bufferTimeAfter'],
        'bufferTimeBefore': !(0, runtime_1.exists)(json, 'bufferTimeBefore') ? undefined : json['bufferTimeBefore'],
        'maximumLeadTimeDays': !(0, runtime_1.exists)(json, 'maximumLeadTimeDays') ? undefined : json['maximumLeadTimeDays'],
        'mimimumLeadTimeDays': !(0, runtime_1.exists)(json, 'mimimumLeadTimeDays') ? undefined : json['mimimumLeadTimeDays'],
        'productId': !(0, runtime_1.exists)(json, 'productId') ? undefined : json['productId'],
        'publicOrder': !(0, runtime_1.exists)(json, 'publicOrder') ? undefined : json['publicOrder'],
        'secret': !(0, runtime_1.exists)(json, 'secret') ? undefined : json['secret'],
        'startTimeInterval': !(0, runtime_1.exists)(json, 'startTimeInterval') ? undefined : json['startTimeInterval'],
        'maximumDayUsage': !(0, runtime_1.exists)(json, 'maximumDayUsage') ? undefined : json['maximumDayUsage'],
        'minimumLeadTimeHours': !(0, runtime_1.exists)(json, 'minimumLeadTimeHours') ? undefined : json['minimumLeadTimeHours'],
        'maximumWeekUsage': !(0, runtime_1.exists)(json, 'maximumWeekUsage') ? undefined : json['maximumWeekUsage'],
        'roundRobin': !(0, runtime_1.exists)(json, 'roundRobin') ? undefined : (0, SchedulerRoundRobin_1.SchedulerRoundRobinFromJSON)(json['roundRobin']),
        'reminders': !(0, runtime_1.exists)(json, 'reminders') ? undefined : json['reminders'],
        'reschedulingOptions': !(0, runtime_1.exists)(json, 'reschedulingOptions') ? undefined : (0, SchedulerReschedulingOptions_1.SchedulerReschedulingOptionsFromJSON)(json['reschedulingOptions']),
        'groupScheduler': !(0, runtime_1.exists)(json, 'groupScheduler') ? undefined : (0, SchedulerGroupScheduler_1.SchedulerGroupSchedulerFromJSON)(json['groupScheduler']),
        'billingRateId': !(0, runtime_1.exists)(json, 'billingRateId') ? undefined : json['billingRateId'],
    };
}
exports.SchedulerFromJSONTyped = SchedulerFromJSONTyped;
function SchedulerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'title': value.title,
        'status': value.status,
        'slug': value.slug,
        'smartActions': value.smartActions,
        'messagingInvite': value.messagingInvite,
        'icon': value.icon,
        'duration': value.duration,
        'communication': (value.communication.map(SchedulerCommunicationInner_1.SchedulerCommunicationInnerToJSON)),
        'availabilityId': value.availabilityId,
        'description': value.description,
        'sharedWith': value.sharedWith,
        'bufferTimeAfter': value.bufferTimeAfter,
        'bufferTimeBefore': value.bufferTimeBefore,
        'maximumLeadTimeDays': value.maximumLeadTimeDays,
        'mimimumLeadTimeDays': value.mimimumLeadTimeDays,
        'productId': value.productId,
        'publicOrder': value.publicOrder,
        'secret': value.secret,
        'startTimeInterval': value.startTimeInterval,
        'maximumDayUsage': value.maximumDayUsage,
        'minimumLeadTimeHours': value.minimumLeadTimeHours,
        'maximumWeekUsage': value.maximumWeekUsage,
        'roundRobin': (0, SchedulerRoundRobin_1.SchedulerRoundRobinToJSON)(value.roundRobin),
        'reminders': value.reminders,
        'reschedulingOptions': (0, SchedulerReschedulingOptions_1.SchedulerReschedulingOptionsToJSON)(value.reschedulingOptions),
        'groupScheduler': (0, SchedulerGroupScheduler_1.SchedulerGroupSchedulerToJSON)(value.groupScheduler),
        'billingRateId': value.billingRateId,
    };
}
exports.SchedulerToJSON = SchedulerToJSON;
//# sourceMappingURL=Scheduler.js.map